// helpers/queueHelpers.js
export const getArrPeriods = () => {
  const curDate = new Date();
  const startPeriod = new Date('2024-10-01');
  const [curY, curM] = [curDate.getFullYear(), curDate.getMonth()];

  const periods = [`${curM + 1}.${curY}`];

  for (;;) {
    const [cM, cY] = periods[periods.length - 1].split('.');
    const newM = (+cM - 1) > 0 ? (+cM - 1) : 12;
    const newY = (+cM - 1) > 0 ? (+cY) : (+cY - 1);

    if (new Date(newY, newM - 1, 2) < startPeriod) break;
    periods.push(`${newM}.${newY}`);
  }

  return periods;
};

export const processQueueData = (data) => {
  if (!data || !Array.isArray(data)) return [];

  return data
    .sort((a, b) => {
      if (a.district > b.district) return 1;
      if (a.district < b.district) return -1;
      return 0;
    })
    .map((item, index) => {
      const { queue, kindergartenNumber, district } = item;
      const ranges = {};

      // Обробка даних черги
      for (const q of (queue[0] && queue[0].requests || [])) {
        const rangeIndex = parseInt(q.range);
        if (!ranges[rangeIndex]) ranges[rangeIndex] = 0;
        ranges[rangeIndex] += 1;
      }

      return {
        number: index + 1,
        district,
        kindergartenNumber,
        ...ranges
      };
    });
};